export const toLine = value => Array.isArray(value)
    ? value.filter(x => !! x).join(' • ')
    : value

export const humanJoin = (array, glue = ', ', finalGlue = ' and ') =>
    [array.slice(0, -1).join(glue), ...array.slice(-1)]
        .filter(x => x !== '')
        .join(finalGlue)
